module.exports = __webpack_public_path__ + "static/img/emoji-2X.6cf46809.png";